module.exports = __webpack_public_path__ + "static/schema-2-d7ce21421509624f0828e35ae9a9e2ba.svg";